import { Inspect } from '../../../../components/Inspect'

export const InspectMIT = ({ goBackToPage, pages, values }) => {
  return Inspect({
    goBackToPage,
    pages,
    values,
    allegationDetails: [
      {
        heading: 'Allegation type',
        field_name: 'allegation',
        value: 'Medical identity theft',
        omitEdit: true
      }
    ]
  })
}
